import { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ConfirmDialogProps {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: 'danger' | 'default';
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title = 'Confirmar',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  tone = 'danger',
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  const confirmCls = tone === 'danger'
    ? 'bg-rose-500/20 text-rose-300 hover:bg-rose-500/30'
    : 'bg-mbc-orange text-white hover:bg-mbc-orangel';

  return createPortal(
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-black/70" onClick={onCancel} />
      <div className="absolute inset-0 grid place-items-center p-4 pointer-events-none">
        <div className="card glow pointer-events-auto w-full max-w-sm rounded-2xl p-5">
          <h3 className="text-base font-bold text-white">{title}</h3>
          <p className="mt-2 text-sm text-mbc-soft">{message}</p>
          <div className="mt-5 flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="rounded-xl border border-mbc-line bg-mbc-panel2 px-4 py-2 text-sm text-mbc-soft hover:text-white"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={busy}
              className={`rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-40 ${confirmCls}`}
            >
              {busy ? '…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
